/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiButton from '@material-ui/core/Button';
import _ from 'lodash';

import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import styles, { useStyles } from './styles';

import Check from '../../Icons/Check';
import CheckSelected from '../../Icons/CheckSelected';
import Pagination from '../Pagination';
const DetailView = ({
  classes,
  builder,
  acceptImages,
  rejectImages,
  loading,
}) => {
  // const loading = true;
  const pageLength = 8;
  // eslint-disable-next-line no-unused-vars
  const [images, setImages] = useState([]);
  const [page, setPage] = useState(0);
  const [radio, setRadio] = useState('');
  const [openConfirmation, setOpenConfirmation] = useState({
    open: false,
    message: null,
    imageIds: [],
    accept: false,
  });
  //   useEffect(() => {
  //     console.log('Page changed', builder.files);
  //     setImages(builder.files.splice(page, pageLength));
  //   }, [page]);

  const handleClose = () => {
    setOpenConfirmation({ open: false });
    setRadio('');
  };

  const handleAccept = (imageIds, accept) => {
    console.log('Imageids', imageIds);
    console.log('accept', accept);
    if (accept) {
      acceptImages(imageIds);
    } else {
      rejectImages(imageIds);
    }
    setOpenConfirmation({ open: false });
    setRadio('');
  };

  useEffect(() => {
    if (builder.files)
      setImages(
        [...builder.files].splice(
          page * pageLength,
          page * pageLength + pageLength,
        ),
      );
  }, [builder, page]);
  const style = useStyles();
  return (
    <Grid container className={classes.container}>
      {loading ? (
        // <CircularProgress size={40} />
        ''
      ) : (
        <>
          <Grid className={classes.radioContainer} xs={12}>
            <Grid xs={12} className={classes.name}>
              {builder.name}
            </Grid>
            <FormControl component="fieldset" style={{ width: '100%' }}>
              <RadioGroup
                row
                classes={style}
                aria-label="action"
                name="action"
                value={radio}
                onChange={e => {
                  const { value } = e.target;
                  setRadio(value);

                  let accept = true;
                  let message = '';
                  let imageIds = [];
                  if (value === 'accept-all') {
                    imageIds = images.map(i => i.id);
                    message = 'Are you sure to accept all photos?';
                  } else if (value === 'reject-all') {
                    imageIds = images.map(i => i.id);
                    accept = false;
                    message = 'Are you sure to reject all photos?';
                  } else if (value === 'accept-selected') {
                    imageIds = images
                      .filter(i => i.isChecked === true)
                      .map(i => i.id);
                    message = 'Are you sure to accept all selected photos?';
                  } else if (value === 'reject-selected') {
                    imageIds = images
                      .filter(i => i.isChecked === true)
                      .map(i => i.id);
                    accept = false;
                    message = 'Are you sure to reject all selected photos?';
                  }
                  console.log(imageIds);
                  // if (accept) {
                  //   acceptImages(imageIds);
                  // } else {
                  //   rejectImages(imageIds);
                  // }
                  setOpenConfirmation({
                    open: true,
                    message,
                    imageIds,
                    accept,
                  });
                }}
                className={classes.radioGroup}
              >
                <FormControlLabel
                  value="accept-all"
                  control={<Radio />}
                  label="ACCEPT ALL (ON THIS PAGE)"
                />
                <FormControlLabel
                  value="reject-all"
                  control={<Radio />}
                  label="REJECT ALL (ON THIS PAGE)"
                />
                <FormControlLabel
                  disabled={
                    images.filter(i => i.isChecked === true).length === 0
                  }
                  value="accept-selected"
                  control={<Radio />}
                  label="ACCEPT SELECTED (ON THIS PAGE)"
                />
                <FormControlLabel
                  disabled={
                    images.filter(i => i.isChecked === true).length === 0
                  }
                  value="reject-selected"
                  control={<Radio />}
                  label="REJECTED SELECTED (ON THIS PAGE)"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid container spacing={4}>
            {images.map(photo => (
              <Grid item lg={3} md={4} sm={6} key={images.id}>
                <div className={classes.imageContainer}>
                  <div
                    className={classes.innercontainer}
                    onClick={() => {
                      console.log('clicked');
                      images.map(p => {
                        if (p === photo) p.isChecked = !p.isChecked;
                        return p;
                      });
                      setImages(
                        [..._.get(builder, 'files', [])].splice(
                          page * pageLength,
                          page * pageLength + pageLength,
                        ),
                      );
                    }}
                  >
                    <img src={photo.file} alt="builder-pics" />
                    <Grid className={classes.checkIcon}>
                      {photo.isChecked ? <CheckSelected /> : <Check />}
                    </Grid>
                  </div>
                  <div className={classes.buttonContainer}>
                    <Button
                      variant="contained"
                      className={classes.acceptButton}
                      onClick={() => {
                        acceptImages([photo.id]);
                      }}
                    >
                      ACCEPT
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.rejectButton}
                      onClick={() => {
                        rejectImages([photo.id]);
                      }}
                    >
                      REJECT
                    </Button>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
          <Grid className={classes.paginationContainer} justify="center">
            <Pagination
              classes={classes}
              showNext={
                _.get(builder, 'files.length', 0) > (page + 1) * pageLength
              }
              showPrev={page > 0}
              onChangePage={value => {
                console.log('OnPageChange', page);
                setPage(page + value);
              }}
            />
          </Grid>
        </>
      )}
      <Dialog
        open={openConfirmation.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {openConfirmation.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={handleClose}>Cancel</MuiButton>
          <MuiButton
            onClick={() => {
              handleAccept(openConfirmation.imageIds, openConfirmation.accept);
            }}
            autoFocus
          >
            Ok
          </MuiButton>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default withStyles(styles)(DetailView);
